import * as React from "../../_snowpack/pkg/react.js";
import SocietyEntry from "./SocietyEntry.js";
import UKAgreement from "./UKAgreement.js";
const IOPEntry = ({society}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SocietyEntry, {
    society
  }), isOpen ? /* @__PURE__ */ React.createElement(UKAgreement, {
    handler: setIsOpen
  }) : /* @__PURE__ */ React.createElement("button", {
    className: "underline my-2",
    onClick: () => setIsOpen(true)
  }, "Click to see details of this agreement"));
};
export default IOPEntry;
